<template>
  <div>
    <!-- AppBar -->
    <v-app-bar color="primary" class="flex-grow-0" app dark elevation="4">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title class="d-flex align-center">
        <v-avatar size="36" class="mr-2" v-if="logo">
          <img :src="urlImagen(logo)" alt="Logo" style="object-fit:contain;" />
        </v-avatar>
        <span class="font-weight-bold text-truncate" style="max-width:180px">{{ nombreGimnasio || 'GymPro' }}</span>
      </v-toolbar-title>
      <v-spacer />

      <!-- Búsqueda global (solo admin y recepcionista) -->
      <template v-if="rol !== 'entrenador'">
        <v-text-field
          v-model="terminoBusqueda"
          prepend-inner-icon="mdi-magnify"
          placeholder="Buscar miembro..."
          solo-inverted flat hide-details dense
          class="hidden-xs-only mr-2"
          style="max-width:260px"
          @input="onBuscar"
          clearable
        />
        <v-btn icon class="hidden-sm-and-up" @click="mostrarBusquedaMovil = !mostrarBusquedaMovil">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>

      <!-- Badge de alertas -->
      <v-btn icon @click="$router.push('/alertas').catch(()=>{})">
        <v-badge :content="totalAlertas" :value="totalAlertas > 0" color="error" overlap>
          <v-icon>mdi-bell-outline</v-icon>
        </v-badge>
      </v-btn>

      <!-- Toggle modo oscuro -->
      <v-btn icon @click="$emit('toggleDark')" :title="$vuetify.theme.dark ? 'Modo claro' : 'Modo oscuro'">
        <v-icon>{{ $vuetify.theme.dark ? 'mdi-white-balance-sunny' : 'mdi-weather-night' }}</v-icon>
      </v-btn>

      <!-- Salir -->
      <v-btn icon @click="salir" title="Cerrar sesión">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- Búsqueda móvil -->
    <v-expand-transition>
      <v-app-bar v-if="mostrarBusquedaMovil && rol !== 'entrenador'" color="primary" dark app style="top:56px;height:56px;">
        <v-text-field
          v-model="terminoBusqueda"
          prepend-inner-icon="mdi-magnify"
          placeholder="Buscar miembro..."
          solo-inverted flat hide-details
          @input="onBuscar"
          clearable autofocus class="mt-1"
        />
      </v-app-bar>
    </v-expand-transition>

    <!-- Resultados de búsqueda -->
    <v-card v-if="resultadosBusqueda" class="busqueda-resultados elevation-8"
      style="position:fixed;top:64px;right:16px;width:340px;z-index:9999;max-height:400px;overflow-y:auto;">
      <v-list dense>
        <v-subheader v-if="resultadosBusqueda.miembros && resultadosBusqueda.miembros.length">MIEMBROS</v-subheader>
        <v-list-item
          v-for="m in resultadosBusqueda.miembros" :key="'m'+m.id"
          @click="irAMiembro(m)"
        >
          <v-list-item-avatar size="32"><img :src="urlImagen(m.imagen)" /></v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ m.nombre }}</v-list-item-title>
            <v-list-item-subtitle>{{ m.matricula }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-chip x-small :color="m.estado === 'ACTIVO' ? 'success' : 'error'" dark>{{ m.estado || 'SIN' }}</v-chip>
        </v-list-item>
        <v-list-item v-if="!resultadosBusqueda.miembros || !resultadosBusqueda.miembros.length">
          <v-list-item-subtitle>Sin resultados</v-list-item-subtitle>
        </v-list-item>
      </v-list>
      <v-card-actions>
        <v-btn text small @click="resultadosBusqueda = null">Cerrar</v-btn>
      </v-card-actions>
    </v-card>

    <!-- Menú lateral -->
    <v-navigation-drawer app v-model="drawer" class="fondo">
      <!-- Cabecera del drawer -->
      <v-list-item class="py-3">
        <v-list-item-avatar size="48" color="white">
          <img v-if="logo" :src="urlImagen(logo)" style="object-fit:contain;" />
          <v-icon v-else color="primary" large>mdi-dumbbell</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-h6 white--text font-weight-bold text-truncate">
            {{ nombreGimnasio || 'GymPro' }}
          </v-list-item-title>
          <v-list-item-subtitle class="white--text">
            <v-icon small color="white">mdi-account</v-icon>
            {{ nombreUsuario }}
            <v-chip x-small class="ml-1" :color="chipRol.color" dark>
              <v-icon x-small left>{{ chipRol.icon }}</v-icon>
              {{ chipRol.label }}
            </v-chip>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider style="border-color:rgba(255,255,255,0.3);" />

      <v-list dense nav class="mt-1">
        <v-list-item
          v-for="item in itemsVisibles"
          :key="item.title"
          link :to="item.link"
          class="white--text mb-1"
          active-class="nav-activo"
        >
          <v-list-item-icon>
            <v-icon class="white--text">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
          <v-badge v-if="item.badge && totalAlertas > 0" :content="totalAlertas" color="error" inline />
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="pa-3 text-center white--text text-caption opacity-75">
          GymPro · By: Dvarela
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import Utiles from '../Servicios/Utiles'
import HttpService from '../Servicios/HttpService'

export default {
  name: 'Encabezado',
  data: () => ({
    drawer: null,
    nombreUsuario: '',
    nombreGimnasio: '',
    logo: '',
    rol: 'recepcionista',
    terminoBusqueda: '',
    resultadosBusqueda: null,
    mostrarBusquedaMovil: false,
    totalAlertas: 0,
    busquedaTimer: null,

    // ── Tabla de items por rol ────────────────────────────────
    items: [
      // Admin ve todo
      { title: 'Inicio',            icon: 'mdi-view-dashboard',    link: '/',                 roles: ['admin', 'recepcionista', 'entrenador'] },
      { title: 'Registrar visita',  icon: 'mdi-home-account',      link: '/registrar-visita', roles: ['admin', 'recepcionista', 'entrenador'] },
      { title: 'Miembros',          icon: 'mdi-weight-lifter',     link: '/miembros',         roles: ['admin', 'recepcionista', 'entrenador'] },
      { title: 'Nuevo miembro',     icon: 'mdi-account-plus',      link: '/nuevo-miembro',    roles: ['admin', 'recepcionista', 'entrenador'] },
      { title: 'Pagos',             icon: 'mdi-account-cash',      link: '/pagos',            roles: ['admin', 'recepcionista', 'entrenador'] },
      { title: 'Alertas',           icon: 'mdi-bell-alert',        link: '/alertas',          roles: ['admin', 'recepcionista', 'entrenador'], badge: true },
      { title: 'Visitas',           icon: 'mdi-calendar-star',     link: '/visitas',          roles: ['admin', 'recepcionista'] },
      { title: 'Membresías',        icon: 'mdi-wallet-membership', link: '/membresias',       roles: ['admin'] },
      { title: 'Reportes',          icon: 'mdi-chart-bar',         link: '/reportes',         roles: ['admin'] },
      { title: 'Usuarios',          icon: 'mdi-account-box',       link: '/usuarios',         roles: ['admin'] },
      { title: 'Configuración',     icon: 'mdi-cog',               link: '/configurar',       roles: ['admin'] },
      { title: 'Mi perfil',         icon: 'mdi-account-key',       link: '/perfil',           roles: ['admin', 'recepcionista', 'entrenador'] },
    ],
  }),

  computed: {
    itemsVisibles() {
      return this.items.filter(item => item.roles.includes(this.rol))
    },
    chipRol() {
      const mapa = {
        admin:         { label: 'Admin',       icon: 'mdi-shield-crown', color: 'amber darken-2' },
        entrenador:    { label: 'Entrenador',   icon: 'mdi-dumbbell',     color: 'blue darken-1' },
        recepcionista: { label: 'Recepción',    icon: 'mdi-desk',         color: 'teal darken-1' },
      }
      return mapa[this.rol] || mapa.recepcionista
    },
  },

  mounted() {
    this.nombreUsuario  = localStorage.getItem('nombreUsuario') || ''
    this.nombreGimnasio = localStorage.getItem('nombreGimnasio') || ''
    this.logo           = localStorage.getItem('logoGimnasio') || ''
    this.rol            = localStorage.getItem('rolUsuario') || 'recepcionista'
    this.cargarAlertas()
  },

  methods: {
    urlImagen(img) { return Utiles.generarURL(img) },

    salir() {
      localStorage.clear()
      window.location.reload()
    },

    async onBuscar() {
      clearTimeout(this.busquedaTimer)
      const t = this.terminoBusqueda
      if (!t || t.length < 2) { this.resultadosBusqueda = null; return }
      this.busquedaTimer = setTimeout(async () => {
        this.resultadosBusqueda = await HttpService.buscar(t)
      }, 350)
    },

    irAMiembro(miembro) {
      this.resultadosBusqueda = null
      this.terminoBusqueda = ''
      this.$router.push({ name: 'EditarMiembro', params: { id: miembro.id } }).catch(() => {})
    },

    async cargarAlertas() {
      try {
        const data = await HttpService.obtenerAlertas()
        if (data && data.resumen) this.totalAlertas = data.resumen.urgente || 0
      } catch (e) { /* silencioso */ }
    },
  },
}
</script>

<style scoped>
.fondo {
  background: linear-gradient(160deg, #1706FF 0%, #0D47A1 60%, #0a2e6e 100%);
}
.nav-activo {
  background: rgba(255, 255, 255, 0.2) !important;
  border-radius: 8px;
}
.busqueda-resultados {
  border-radius: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Encabezado.vue